import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { BrandConfig, BrandType } from '../models/brand.model';
import { LocationPartnerType } from '../models/location.model';

@Injectable({ providedIn: 'root' })
export class BrandStore {
  private readonly brandSubject = new BehaviorSubject<BrandConfig | null>(null);

  /** May be null before location is loaded */
  readonly maybeBrand$: Observable<BrandConfig | null> = this.brandSubject.asObservable();

  /** Emits only once a non-null brand has been set */
  readonly brand$: Observable<BrandConfig> = this.maybeBrand$.pipe(filter((b): b is BrandConfig => b !== null));

  /** Called once the location is available */
  setFromPartnerType(partnerType?: LocationPartnerType): void {
    const type = partnerType === LocationPartnerType.Reseller ? BrandType.Debranded : BrandType.Timetailor;
    this.brandSubject.next(this.buildConfig(type));
  }

  getSnapshot(): BrandConfig {
    const current = this.brandSubject.value;
    if (current) return current;

    const fallback = this.buildConfig(BrandType.Timetailor);
    this.brandSubject.next(fallback);
    return fallback;
  }

  isTimetailor(): boolean {
    return this.getSnapshot().type === BrandType.Timetailor;
  }

  isDebranded(): boolean {
    return this.getSnapshot().type === BrandType.Debranded;
  }

  private buildConfig(type: BrandType): BrandConfig {
    if (type === BrandType.Debranded) {
      return {
        name: 'SalonLogin',
        type,
        domain: 'www.globaltech-studio.com',
      };
    }

    return {
      name: 'TimeTailor',
      type,
      domain: 'www.timetailor.com',
    };
  }
}
